import script from "./HeaderMessagesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderMessagesModal.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderMessagesModal.vue?vue&type=style&index=0&id=56441973&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56441973"]])

export default __exports__